<template>
  <!-- 德纳看板 -->
  <div class="usePowerUnitBody custom-scrollbar">
    <!-- 通用-单位信息 -->
    <unitInfo class="smallWindow"></unitInfo>

    <!-- 通用-月事件告警统计环比 -->
    <!-- <workStateNoWork2 class="smallWindow"></workStateNoWork2> -->
    <!-- 用电峰平谷 -->
    <peakAndFlat class="smallWindow" style="margin-left: 12px;"></peakAndFlat>
    <!--单位日负荷 -->
    <dayInfo class="marginTop bigWindow" :flag="1"></dayInfo>
    <!-- 单位用电量统计 -->
    <yearOrMonthkWh class="marginTop bigWindow"></yearOrMonthkWh>
    <div style="height: 10px;width: 100%;"></div>
  </div>
</template>

<script>
  import unitInfo from '@/page/projectDingZhi/quanSheng/unitInfo.vue'
  import peakAndFlat from '@/page/projectDingZhi/quanSheng/peakAndFlat.vue'
  import workStateNoWork from '@/page/unitKanBan/component/workStateNoWork.vue'
  import workStateNoWork2 from '@/page/unitKanBan/component/workStateNoWork2.vue'
  import dayInfo from '@/page/projectDingZhi/quanSheng/dayInfo.vue'
  import yearOrMonthkWh from '@/page/projectDingZhi/quanSheng/yearOrMonthkWh2.vue'
  import unitStore from '@/cache/unitStore.js'
  export default {
    components: {
      unitInfo,
      peakAndFlat,
      dayInfo,
      yearOrMonthkWh,
      workStateNoWork,
      workStateNoWork2
    },
    props: [],
    data () {
      return {}
    },
    created () {

    },
    mounted () {},
    destroyed () {},
    computed: {
    },
    watch: {},
    methods: {

    }
  }
</script>

<style scoped>
  .usePowerUnitBody {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    height: calc(100% - 80px) !important;
    padding: 1%;
    overflow: auto;
  }

  .smallWindow {
    width: calc(50% - 6px);
    height: 270px;
  }

  .smallWindowMargin {
    margin-right: 8px;
  }

  .marginTop {
    margin-top: 8px;
  }

  .bigWindow {
    width: 100%;
    height: 270px;
  }

  @media screen and (max-width: 1200px) {
    .smallWindow {
      width: 100%;
    }

    .smallWindowMargin {
      margin-right: 0;
      margin-bottom: 8px;
    }

    .bigWindow {
      height: auto;
      min-height: 270px;
    }
  }
</style>